export default __webpack_public_path__ + "static/media/astronauta.667b1997.png";